import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTextIndentLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconTextIndentLeft"><Path fillRule="evenodd" clipRule="evenodd" d="M9 5H22V7H9V5ZM9 5H22V7H9V5ZM9 5H22V7H9V5Z" fill="currentColor"/><Path d="M22 11V13H9V11H22Z" fill="currentColor"/><Path d="M22 17V19H9V17H22Z" fill="currentColor"/><Path d="M2 15.5V8.5L7 12L2 15.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconTextIndentLeft;
